import {
    createSlice
} from "@reduxjs/toolkit";
import { getNotificationAll } from "./thunk";
export const initialState = {
    notificationAll: [],
    error: "", // for error message
    loading: false,
};

const notificationAllSlice = createSlice({
    name: "notificationAll",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getNotificationAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getNotificationAll.fulfilled, (state, action) => {
                state.notificationAll = action.payload;
                state.loading = false;
            })
            .addCase(getNotificationAll.rejected, (state, action) => {
                state.error = action.payload ? action.payload?.error : action.error.message;
                state.loading = false;
            })
    }
});


export default notificationAllSlice.reducer;